import { parseSolutionDetailContent } from './solutionDetailContent';

const buildStaticWhyChoose = () => ({
  title: 'Why Choose VBS',
  description:
    'We combine institutional expertise with a tailored approach, ensuring every solution is aligned with your specific financial goals.',
  items: [
    {
      title: 'Expertise & Specialization',
      text: 'Deep understanding of markets, regulations, and emerging trends.',
    },
    {
      title: 'Tailored Solutions',
      text: 'Strategies designed around your objectives, structure, and operating reality.',
    },
    {
      title: 'Proactive Risk Management',
      text: 'Identifying exposures early and building controls that protect long-term value.',
    },
  ],
  image: '',
});

const buildStaticHowWeWork = () => ({
  title: 'How We Work',
  steps: [
    {
      number: '1.',
      title: 'Discovery',
      description: 'Understanding your objectives, challenges, and constraints.',
    },
    {
      number: '2.',
      title: 'Analysis',
      description: 'Evaluating financial data, market conditions, and risks.',
    },
    {
      number: '3.',
      title: 'Strategy',
      description: 'Designing tailored solutions aligned with your goals.',
    },
    {
      number: '4.',
      title: 'Execution',
      description: 'Implementing and optimizing strategies with ongoing support.',
    },
  ],
});

export const buildStaticSolutionDetailContent = (solution) => ({
  hero: {
    category: solution.category,
    title: solution.title,
    description: solution.heroDescription,
    cta: {
      text: 'Contact Us',
      url: '/contact',
    },
    backgroundImage: '',
  },
  view: {
    title: solution.viewTitle,
    description: solution.viewDescription,
    items: solution.viewItems,
    checkIcon: '',
  },
  whatWeDeliver: {
    title: 'What We Deliver',
    items: solution.deliverables.map((item) => ({
      ...item,
      icon: '',
    })),
  },
  whyChoose: buildStaticWhyChoose(),
  howWeWork: buildStaticHowWeWork(),
  timeIsValuable: {
    title: "Time Is Valuable. Let's Start Now.",
    text: `Speak with our team to explore how VBS ${solution.category} can strengthen your financial operations and long-term readiness.`,
    cta: {
      text: 'Schedule a Consultation',
      url: '/contact',
    },
  },
});

export const resolveSolutionDetailContent = (page, solution) => {
  const parsed = parseSolutionDetailContent(page);
  const fallback = buildStaticSolutionDetailContent(solution);

  if (!parsed) {
    return fallback;
  }

  return {
    hero: parsed.hero || fallback.hero,
    view: parsed.view || fallback.view,
    whatWeDeliver: parsed.whatWeDeliver || fallback.whatWeDeliver,
    whyChoose: parsed.whyChoose || fallback.whyChoose,
    howWeWork: parsed.howWeWork || fallback.howWeWork,
    timeIsValuable: parsed.timeIsValuable || fallback.timeIsValuable,
  };
};
